// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure header is a positioned ancestor for absolute placement */
.modern-header {
  position: relative;
}

/* Top-right flag container */
.language-switcher {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 70;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}

/* On RTL, place on the left */
[dir="rtl"] .language-switcher {
  left: 16px;
  right: auto;
}

/* Flag button: transparent background (flags only) */
.flag-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 36px;
  height: 36px;
  border-radius: 8px;
  background: transparent; /* flags only */
  border: none;
  cursor: pointer;
  transition: transform .12s ease, box-shadow .12s ease, opacity .12s;
  padding: 6px;
  outline: none;
  color: inherit;
}

/* Hover affordance: subtle backdrop so the flag is still easy to tap */
.flag-button:hover {
  background: rgba(15, 23, 42, 0.04);
  transform: translateY(-2px);
}
.flag-button:active { transform: translateY(0); }

/* SVG inside button */
.flag-svg svg {
  width: 22px;
  height: 14px;
  display: block;
}

/* small caret */
.flag-caret {
  font-size: 12px;
  opacity: 0.9;
}

/* Dropdown */
.lang-dropdown {
  position: absolute;
  top: 52px;
  right: 0;
  min-width: 180px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e6eef0;
  box-shadow: 0 6px 24px rgba(2,6,23,0.12);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* RTL dropdown placement */
[dir="rtl"] .lang-dropdown {
  left: 0;
  right: auto;
}

/* Option */
.lang-option {
  display: flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: none;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #0f172a;
  text-align: left;
}

.lang-option .lang-flag svg {
  width: 26px;
  height: 18px;
  display: inline-block;
}

/* label flex */
.lang-label {
  flex: 1 1 auto;
}

/* hover/selected */
.lang-option:hover {
  background: #f8fafc;
}

.lang-option.selected {
  background: rgba(6,95,64,0.06);
  font-weight: 600;
  color: #064e3b;
}

/* small check */
.lang-check {
  margin-left: auto;
  color: #059669;
  font-weight: 700;
}

/* Accessibility helpers (visually hidden) */
.sr-only {
  position: absolute !important;
  height: 1px; width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}

/* Make switcher non-intrusive on mobile: reduce top offset if header is taller */
@media (max-width: 640px) {
  .language-switcher { top: 8px; right: 10px; }
  [dir="rtl"] .language-switcher { left: 10px; right: auto; }
  .flag-button { min-width: 34px; height: 34px; }
  .lang-dropdown { top: 46px; min-width: 140px; }
}`, "",{"version":3,"sources":["webpack://./src/styles/language-switcher.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,WAAW;AACb;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB,EAAE,eAAe;EACxC,YAAY;EACZ,eAAe;EACf,mEAAmE;EACnE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA,sBAAsB,wBAAwB,EAAE;;AAEhD,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,YAAY;AACd;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE,OAAO;EACP,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,WAAW,EAAE,UAAU;EACvB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,qBAAqB,QAAQ,EAAE,WAAW,EAAE;EAC5C,iCAAiC,UAAU,EAAE,WAAW,EAAE;EAC1D,eAAe,eAAe,EAAE,YAAY,EAAE;EAC9C,iBAAiB,SAAS,EAAE,gBAAgB,EAAE;AAChD","sourcesContent":["/* Ensure header is a positioned ancestor for absolute placement */\n.modern-header {\n  position: relative;\n}\n\n/* Top-right flag container */\n.language-switcher {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  z-index: 70;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: inherit;\n}\n\n/* On RTL, place on the left */\n[dir=\"rtl\"] .language-switcher {\n  left: 16px;\n  right: auto;\n}\n\n/* Flag button: transparent background (flags only) */\n.flag-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: transparent; /* flags only */\n  border: none;\n  cursor: pointer;\n  transition: transform .12s ease, box-shadow .12s ease, opacity .12s;\n  padding: 6px;\n  outline: none;\n  color: inherit;\n}\n\n/* Hover affordance: subtle backdrop so the flag is still easy to tap */\n.flag-button:hover {\n  background: rgba(15, 23, 42, 0.04);\n  transform: translateY(-2px);\n}\n.flag-button:active { transform: translateY(0); }\n\n/* SVG inside button */\n.flag-svg svg {\n  width: 22px;\n  height: 14px;\n  display: block;\n}\n\n/* small caret */\n.flag-caret {\n  font-size: 12px;\n  opacity: 0.9;\n}\n\n/* Dropdown */\n.lang-dropdown {\n  position: absolute;\n  top: 52px;\n  right: 0;\n  min-width: 180px;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid #e6eef0;\n  box-shadow: 0 6px 24px rgba(2,6,23,0.12);\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* RTL dropdown placement */\n[dir=\"rtl\"] .lang-dropdown {\n  left: 0;\n  right: auto;\n}\n\n/* Option */\n.lang-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: transparent;\n  border: none;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #0f172a;\n  text-align: left;\n}\n\n.lang-option .lang-flag svg {\n  width: 26px;\n  height: 18px;\n  display: inline-block;\n}\n\n/* label flex */\n.lang-label {\n  flex: 1 1 auto;\n}\n\n/* hover/selected */\n.lang-option:hover {\n  background: #f8fafc;\n}\n\n.lang-option.selected {\n  background: rgba(6,95,64,0.06);\n  font-weight: 600;\n  color: #064e3b;\n}\n\n/* small check */\n.lang-check {\n  margin-left: auto;\n  color: #059669;\n  font-weight: 700;\n}\n\n/* Accessibility helpers (visually hidden) */\n.sr-only {\n  position: absolute !important;\n  height: 1px; width: 1px;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n  white-space: nowrap;\n}\n\n/* Make switcher non-intrusive on mobile: reduce top offset if header is taller */\n@media (max-width: 640px) {\n  .language-switcher { top: 8px; right: 10px; }\n  [dir=\"rtl\"] .language-switcher { left: 10px; right: auto; }\n  .flag-button { min-width: 34px; height: 34px; }\n  .lang-dropdown { top: 46px; min-width: 140px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
